import { createContext, useContext, useState, useEffect, useCallback } from 'react';
import axios from 'axios';

const ClientAuthContext = createContext();
const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function ClientAuthProvider({ children }) {
  const [clientUser, setClientUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchMe = useCallback(async () => {
    try {
      const { data } = await axios.get(`${API}/client-auth/me`, { withCredentials: true });
      setClientUser(data);
    } catch {
      setClientUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { fetchMe(); }, [fetchMe]);

  const login = async (email, password) => {
    const { data } = await axios.post(`${API}/client-auth/login`, { email, password }, { withCredentials: true });
    setClientUser(data);
    return data;
  };

  const register = async (email, password, name, phone) => {
    const { data } = await axios.post(`${API}/client-auth/register`, { email, password, name, phone }, { withCredentials: true });
    setClientUser(data);
    return data;
  };

  const logout = async () => {
    await axios.post(`${API}/client-auth/logout`, {}, { withCredentials: true });
    setClientUser(null);
  };

  return (
    <ClientAuthContext.Provider value={{ clientUser, loading, login, register, logout }}>
      {children}
    </ClientAuthContext.Provider>
  );
}

export const useClientAuth = () => useContext(ClientAuthContext);
